export default function BrandMission() {
  const coreValues = [
    {
      title: '功能价值',
      subtitle: '理性层面',
      description: '科学、有效、安全的产品解决方案',
      detail: '云南农大&医疗研究院背书的科学产品矩阵',
      icon: 'ri-flask-line',
      color: 'from-[#847eba] to-[#9d85d1]'
    },
    {
      title: '情感价值',
      subtitle: '感性层面', 
      description: '陪伴、鼓励、不焦虑的温暖体验',
      detail: '瘦瘦哈乐猴IP提供的体重管理过程中的陪伴与快乐',
      icon: 'ri-heart-3-line',
      color: 'from-[#9d85d1] to-[#a3c1c3]'
    },
    {
      title: '精神价值',
      subtitle: '哲学层面',
      description: '追求轻盈健康的过程本身就是一种积极人生',
      detail: '"轻松一点，才轻一点"所代表的生活哲学',
      icon: 'ri-star-smile-line',
      color: 'from-[#a3c1c3] to-[#b8d4c7]'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-[#f8f9fc] to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-32">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl lg:text-4xl font-light text-gray-800 mb-4 lg:mb-6">
            三位一体核心价值
          </h2>
          <p className="text-sm lg:text-lg text-gray-600 font-light max-w-3xl mx-auto">
            对内（心理）：倡导轻松、不焦虑、不自责的健康心态<br />
            对外（身体）：提供科学有效、易于坚持的产品方案
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 mb-12 lg:mb-16">
          {coreValues.map((value, index) => (
            <div key={index} className="group">
              <div className="bg-white rounded-3xl p-6 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-300 h-full border border-gray-100">
                <div className={`w-16 lg:w-20 h-16 lg:h-20 bg-gradient-to-br ${value.color} rounded-2xl flex items-center justify-center mb-6 lg:mb-8 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${value.icon} text-xl lg:text-2xl text-white`}></i>
                </div>
                
                <div className="mb-4 lg:mb-6">
                  <h3 className="text-lg lg:text-xl font-medium text-gray-800 mb-2">
                    {value.title}
                  </h3>
                  <span className="text-xs lg:text-sm text-[#847eba] font-medium">
                    {value.subtitle}
                  </span>
                </div>
                
                <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed mb-3 lg:mb-4">
                  {value.description}
                </p>
                
                <p className="text-xs lg:text-sm text-gray-500 font-light leading-relaxed">
                  {value.detail}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="bg-gradient-to-br from-[#847eba]/5 to-[#a3c1c3]/5 rounded-3xl p-8 lg:p-12 max-w-4xl mx-auto">
            <h3 className="text-lg lg:text-xl font-medium text-gray-800 mb-6 lg:mb-8">
              产品开发理念
            </h3>
            <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed">
              每一款产品都必须是科学之下的<strong className="text-[#847eba]">"轻松哲学"</strong>实体化体现：<br />
              科学有效是基础，易于坚持、体验愉悦才是关键。
            </p>
            
            <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mt-8 lg:mt-12 text-left">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#847eba] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs lg:text-sm text-gray-600 font-light">
                    每个产品都有明确的使用场景和科学依据
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#847eba] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs lg:text-sm text-gray-600 font-light">
                    注重用户体验的愉悦感和便利性
                  </p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#a3c1c3] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs lg:text-sm text-gray-600 font-light">
                    通过IP形象传递温暖陪伴的情感价值
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#a3c1c3] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs lg:text-sm text-gray-600 font-light">
                    坚持长期主义，关注可持续的健康管理
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}